var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditCode = function SvgEditCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.55 61.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-2{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.55,
    y: 8.5,
    width: 53,
    height: 53,
    rx: 8.1,
    ry: 8.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.93,19.96l-4.5,16.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.93,23.18l-4.5,4.5,4.5,4.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.07,23.18l4.5,4.5-4.5,4.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 2,
    width: 52,
    height: 52,
    rx: 5.18,
    ry: 5.18
  }))));
};
export default SvgEditCode;